import { Stack } from "@mui/material";
import { FollowUpPublishButton } from "./follow-up-publish-button";
import { FollowUpSaveDraftButton } from "./follow-up-save-draft-button";
import { FollowUpSentTestButton } from "./follow-up-sent-test-button";

import type { FollowUpPageState } from "../../reducer/actions";
import type { FollowUpButtonsProps } from "./types";
import type { FC } from "react";

export const FollowUpSaveButtons: FC<
  FollowUpButtonsProps & {
    disabled: FollowUpPageState["derivedData"]["uiDisabled"]["buttons"];
  }
> = ({ disabled, ...props }) => (
  <Stack direction="row" spacing={2}>
    <FollowUpSentTestButton {...props} disabled={disabled.sendTest} />
    <FollowUpSaveDraftButton {...props} disabled={disabled.save} />
    <FollowUpPublishButton {...props} disabled={disabled.publish} />
  </Stack>
);
